import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
function getSurfaceUtilityClass(slot) {
  return generateUtilityClass('MuiChartsSurface', slot);
}
export const useUtilityClasses = () => {
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getSurfaceUtilityClass);
};
export const chartsSurfaceClasses = generateUtilityClasses('MuiChartsSurface', ['root']);